import * as Sentry from '@sentry/browser';

export default function captureBreadcrumb(breadcrumb: Sentry.Breadcrumb) {
	Sentry.addBreadcrumb(breadcrumb);
}
